var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var kr_day_month_format = settings.kr_day_month_format || 0;
  var oab_show_month_after_year = settings.oab_show_month_after_year || 0;
  var oab_show_year_suffix = settings.oab_show_year_suffix || 0;
  var oab_start_from_monday = settings.oab_start_from_monday || 0;
  var oab_date_format_jp = settings.oab_date_format_jp || 0;
  var oab_year_suffix = settings.oab_year_suffix || '';
  var oab_month_suffix = settings.oab_month_suffix || '';
  var oab_day_suffix = settings.oab_day_suffix || '';
  var oab_time_format_24h = settings.oab_time_format_24h || 0;
  var oab_date_format_with_dot = settings.oab_date_format_with_dot || 0;
  var oab_cal_header_tmpl = settings.oab_cal_header_tmpl || '[weekof] [m] [d], [y]'; // Example useage is in de.inc
  var oab_cal_header_tmpl_mobile = settings.oab_cal_header_tmpl_mobile || '[m] [d], [y] ';

  function startDayShift(day_nr) {
    // monday has to be day 0 in JS logic, so we have to shift all days by one position
    if (oab_start_from_monday) {
      day_nr = day_nr - 1;
      if (day_nr === -1) {
        // if sunday then assign it to 6
        day_nr = 6;
      }
    }

    return day_nr;
  }

  // padStart polyfill for IE11
  // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
  if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
      targetLength = targetLength >> 0; // truncate if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          // append to original to ensure we are longer than needed
          padString += Array.apply(null, Array(targetLength))
            .map(function () {
              return padString;
            })
            .join('');
        }

        return padString.slice(0, targetLength) + String(this);
      }
    };
  }

  /* Concrete View */
  apptBook.AppointmentSelectSection = function (container) {
    apptBook.AppointmentSelectSection.superclass.constructor.call(this);
    this.id = 'appointments';
    this.jqBod = $('body');
    this.container = container;
    this.servContainer = container.find('.services');
    this.serviceTmpl = this.servContainer.find('.service').remove();
    this.serviceTmplHeader = this.container.find('.book-now-services-header');
    this.changeServices = container.find('#change-services-link');
    this.backTo = container.find('.back-to-link');
    this.minLabel = this.servContainer.attr('data-time-label');
    this.curSymbol = this.servContainer.attr('data-currency-symbol');
    this.locSelect = container.find('select.location-select');
    this.artContainer = container.find('.artist-select-container');
    this.artSelect = this.artContainer.find('select.artist-select');
    this.apptContainer = container.find('.appointment-select');
    this.signInContainer = this.jqBod.find('.sign-in-container');
    this.bookContainer = container.find('.book-appt-container');
    this.bookBar = container.find('.book-now-bar');
    this.totalElem = this.bookBar.find('.total-time');
    this.totalPriceSelectedContainer = this.bookBar.find('.selection-price');
    this.legalCopy = container.find('.services-legal-copy');
    this.totalText = this.totalElem.html();
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.locationConflictOverlay = container.find('.appt-book-location-conflict-overlay').remove();
    this.totalTimeBtn = this.jqBod.find('.js-total_selected_service_time');
    this.totalPriceBtn = this.jqBod.find('.js-total_selected_service_price');
    this.calendarId = '0';
    this.appointmentId = null;
    this.appointmentTime = null;
    this.totalTime = 0;
    this.totalPrice = 0;
    this.slotInterval = 0;
    this.serviceIds = [];
    this.stores = {};
    this.overlayIsOpen = false;
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.AppointmentSelectSection, apptBook.AbstractSection);

  apptBook.AppointmentSelectSection.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Appointment Select & Book';
    var config = Drupal.settings.appointment_booking_main_collection;

    this.serviceIds = [];
    this.totalTime = 0;
    this.totalPrice = 0;
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        var hasVirtual = parseInt(localStorage.getItem('virtual_oab')) || parseInt(me.counterData.virtual) || 0;

        if (hasVirtual) {
          $('.back-to-link', me.container).addClass('hidden');
          $('.selects-container', me.container).addClass('hidden');
          $('.appointment-select > h4', me.container).addClass('hidden');
          $('.virtual-location', me.container).removeClass('hidden');
        }
        me.buildServices();
        me.buildLocation();
        me.buildArtists();
        if (!me.initialized) {
          me.buildApptSelect();
          me.initialized = true;
        } else {
          var date = me.appointmentTime ? dateUtils.convertTimeString(me.appointmentTime) : new Date();
          var dateSet = me.appointmentTime ? 1 : 0;

          me.calModel.update({
            date: date,
            calendarId: me.calendarId,
            counterId: me.counterId,
            apptDur: me.totalTime,
            apptDurWithPadding: me.apptDurWithPadding,
            timeSlotInterval: me.slotInterval,
            serviceIds: me.serviceIds,
            hilite: true,
            dateSet: dateSet,
            openTimes: me.counterData.opening_time_range,
            showNextWeek: true
          });
          if (me.appointmentTime) {
            me.calModel.fire('time_selected', me.appointmentTime);
          } else {
            me.calModel.fire('time_deselected');
          }
        }
      }
    }

    function processUpdate() {
      if (data.params.appointmentId) {
        me.model.getAppointment(
          data.params.appointmentId,
          function (apptData) {
            me.appointmentData = apptData;
            me.updateMode = true;
            me.counterId = me.appointmentData.counter_id;
            me.calendarId = me.appointmentData.calendar_id;
            me.servicesData = [];
            me.appointmentId = apptData.id;
            me.appointmentTime = apptData.start_time;
            me.apptDur = 0;
            me.apptDurWithPadding = 0;

            servs = me.appointmentData.services;

            for (var i = 0, len = servs.length; i < len; i += 1) {
              servObj = servs[i];
              servObj.serviceImg = '';
              servObj.serviceDescription = '';

              // When the user comes to step 3 via the non-edit process, the serviceDescription and serviceImg are populated
              // during service selection on step 2. In this case that will not have occurred and we need to populate it manually here
              var servContent = Drupal.appointmentBooking.serviceContent;

              if (servContent) {
                var matchingServContent;

                for (var j = 0; j < servContent.length; j++) {
                  var thisId = $(servContent[j]).attr('data-content-id');

                  if (thisId === servObj.online_content_id) {
                    matchingServContent = servContent[j];
                  }
                }
                if (matchingServContent) {
                  servObj.serviceImg = $(matchingServContent).find('.service-content__image').attr('src');
                  // Due to lazyloading, the src *may* not be populated, if not grab the image from data-src
                  if (!servObj.serviceImg) {
                    servObj.serviceImg = $(matchingServContent).find('.service-content__image').attr('data-src');
                  }
                  servObj.serviceDescription = $(matchingServContent).find('.js-service-message').html();
                }
              }

              me.servicesData.push({
                serviceDescription: servObj.serviceDescription,
                serviceImg: servObj.serviceImg,
                serviceId: servObj.id,
                serviceDuration: servObj.total_duration,
                servicePrice: servObj.price,
                serviceName: servObj.name
              });

              (me.apptDur += parseInt(servObj.total_duration)),
                (me.apptDurWithPadding += parseInt(servObj.total_duration_with_padding)),
                me.serviceIds.push(servObj.id);
            }

            me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
              me.counterData = data;
              hasCounter = true;
              me.slotInterval = me.counterData.timeslot_interval;
              runUpdate();
            });
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        if (me.counterId !== data.params.counterId) {
          me.calendarId = '0';
        }
        if (!!data.params.startTime) {
          me.appointmentTime = data.params.startTime;
        }
        if (data.params.updateMode) {
          me.updateMode = true;
          me.calendarId = '0';
        } else {
          me.updateMode = false;
        }
        me.counterId = data.params.counterId;
        me.servicesData = data.params.services;
        for (var i = 0, len = me.servicesData.length; i < len; i += 1) {
          me.serviceIds.push(me.servicesData[i].serviceId);
        }

        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      if (typeof data.params.slotInterval != 'undefined') {
        me.slotInterval = data.params.slotInterval;
      }

      if (!!data.params.appointmentDuration) {
        me.apptDur = data.params.appointmentDuration;
        // Only set this if we have a new value. In the case where the user is switching counters AFTER service selection, there will
        // not be a new value for appointment duration, so just continue to use the old one.
        me.apptDurWithPadding = data.params.appointmentDurationWithPadding
          ? data.params.appointmentDurationWithPadding
          : me.apptDurWithPadding;
      }

      me.model.fetchCountersData({ service_id: me.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      if (config.display_sessions_price && config.price_legal_copy) {
        this.legalCopy.show().html(config.price_legal_copy);
        this.totalPriceSelectedContainer.show();
      } else {
        this.legalCopy.hide();
        this.totalPriceSelectedContainer.hide();
      }

      generic.jsonrpc.fetch({
        method: 'user.json',
        // params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildServices = function () {
    var myTmpl,
      sData,
      me = this;

    $(window).on('loadPreviousServicesObjBackButton', function () {
      var upObj = {
        sectionId: 'services',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          serviceIds: me.serviceIds,
          updateMode: me.updateMode
        }
      };

      return upObj;
    });
    this.servContainer.find('.service').remove();
    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      sData = this.servicesData[i];

      // add service description if available
      if (typeof apptBook.sectionModel !== 'undefined' && !sData.serviceDescription) {
        sectionModelService = apptBook.sectionModel.servicesData.filter(function (service) {
          return service.id == sData.serviceId;
        })[0];
        sData.serviceDescription =
          typeof sectionModelService !== 'undefined' ? sectionModelService.description : sData.serviceType;
      }

      myTmpl = this.serviceTmpl.clone();
      this.servContainer.append(myTmpl);
      if (this.servicesData.length == 1) {
        myTmpl.addClass('only-service-selected');
        this.servContainer.addClass('one-service-selected');
      } else {
        this.servContainer.removeClass('one-service-selected');
      }
      myTmpl.attr('data-service-id', sData.serviceId);
      myTmpl.attr('data-service-duration', sData.serviceDuration);
      myTmpl.attr('data-service-price', sData.servicePrice);
      myTmpl.find('.selection-service__details--desc').append(sData.serviceDescription);
      myTmpl.find('.selection-service__title').append(sData.serviceName);
      myTmpl.find('.selection-service__image').attr('src', sData.serviceImg);
      // force capitalization of service name in mobile
      if (site.client.isMobile) {
        this.servContainer.find('.service:first .selection-service .service-select').append(
          '<option value="' +
            sData.serviceName +
            '">' +
            sData.serviceName.toLowerCase().replace(/\b\w/g, function (l) {
              return l.toUpperCase();
            }) +
            '</option>'
        );
      }

      myTmpl.find('.selection-time').append(sData.serviceDuration + ' ' + this.minLabel);
      myTmpl.find('.selection-price').append(this.curSymbol + sData.servicePrice);

      this.totalTime += parseInt(sData.serviceDuration);
      this.totalPrice += sData.servicePrice;

      myTmpl.find('#change-services-link').off('click');
      myTmpl.find('#change-services-link').click(function (e) {
        e.preventDefault();
        me.removeService($(this));
      });
      this.backTo.off('click');
      this.backTo.click(function (e) {
        e.preventDefault();

        var upObj = {
          sectionId: 'services',
          params: {
            sectionId: me.id,
            counterId: me.counterId,
            serviceIds: me.serviceIds,
            updateMode: me.updateMode
          }
        };

        me.model.update(upObj);
      });
    }
    this.serviceTmplHeader.find('.selection-time').html(this.totalTime + ' ' + this.minLabel);
    this.serviceTmplHeader.find('.selection-price').html(this.curSymbol + this.totalPrice);

    if (me.totalPrice > 0) {
      me.totalPriceSelectedContainer.show();
      me.totalPriceBtn.html(me.totalPrice);
    } else {
      me.totalPriceSelectedContainer.hide();
    }

    // set total time button label
    me.totalTimeBtn.html(me.totalTime);
  };

  apptBook.AppointmentSelectSection.prototype.buildLocation = function () {
    var me = this;

    this.locSelect.find('option').remove();
    this.stores = {};
    // get State data for counters
    this.countersData = apptBook.geoLoc.mergeGeoLocWithCounters(this.countersData);
    this.counterData = _.find(this.countersData, { id: me.counterId });
    var colHead =
      this.apptContainer.find('thead.col-heads').attr('data-time-interval') ||
      this.container.find('table.day').attr('data-time-interval');
    var timeInterval = colHead === '0' ? false : colHead;

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var storeName = this.countersData[i].name;
      var optionText = this.countersData[i].town ? this.countersData[i].town + ' - ' + storeName : storeName;
      var optionValue = this.countersData[i].id;
      var newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');
      var storeNum = this.countersData[i].store_no;
      var maxApptServices = this.countersData[i].max_appointment_services;
      var maxApptDuration = this.countersData[i].max_appointment_duration;
      var tSlotInt = timeInterval || this.countersData[i].timeslot_interval;
      var optionState = this.countersData[i].state
        ? this.countersData[i].state.short_name
        : this.countersData[i].county;
      var counterState = this.counterData.state ? this.counterData.state.short_name : this.counterData.county;
      // include counter in menu by default
      var includeCounter = true;

      if (optionState != counterState) {
        // do not add counter to menu if its state does not match selected counter's state
        includeCounter = false;
      }
      // assigning time slot interval value to display either from node or counter
      if (this.counterId === this.countersData[i].id) {
        this.slotInterval = tSlotInt;
      }
      me.stores[optionValue] = {
        store: storeNum,
        name: storeName,
        maxApptDuration: maxApptDuration,
        tSlotInt: tSlotInt
      };

      if (optionValue === this.counterId) {
        newOption.attr('selected', 'selected');
      }
      if (includeCounter) {
        this.locSelect.append(newOption);
      }
    }

    sortLocationOptions();

    function sortLocationOptions() {
      $(me.locSelect).html(
        $(me.locSelect)
          .find('option')
          .sort(function (a, b) {
            return a.text.toUpperCase() > b.text.toUpperCase()
              ? 1
              : a.text.toUpperCase() < b.text.toUpperCase()
              ? -1
              : 0;
          })
      );
    }
    me.locSelect.val(this.counterId); // need to reset the cached select value after a sort
    me.container.find('.selectbox').each(function () {
      $(this).trigger('select.enabled');
    });

    function onLocChange(e) {
      var counterId = this.value,
        upObj = {};

      if (counterId !== me.counterId) {
        me.model.getCounter(counterId, { service_id: me.serviceIds }, function (data) {
          if (!data) {
            return;
          } else if (
            parseInt(data.max_appointment_duration) != 0 &&
            parseInt(data.max_appointment_duration) < me.totalTime
          ) {
            me.locSelect.val(me.counterId);
            me.launchLocationConflictOverlay(data.max_appointment_duration);

            return;
          } else {
            upObj = {
              sectionId: 'appointments',
              params: {
                counterId: counterId,
                services: me.servicesData,
                slotInterval: data.timeslot_interval,
                appointmentDuration: me.totalTime,
                appointmentDurationWithPadding: me.totalTimeWithPadding,
                updateMode: me.updateMode
              }
            };
            me.model.update(upObj);
            site?.track?.evtLink && site.track.evtLink({
              event_name: 'appointmentBooking_reselectLocation',
              event_category: 'appointment booking',
              event_action: 'reselect location',
              event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
            });
          }
        });
      }
    }
    this.locSelect.off('change'); // remove this first just in case we have already been to this screen
    this.locSelect.on('change', onLocChange);
  };

  apptBook.AppointmentSelectSection.prototype.buildArtists = function () {
    var me = this,
      calData = this.counterData.calendars;

    this.artContainer.show();
    // this.artContainer.hide(); // forcing hide per Puneet request 1/24/17
    this.artSelect.find('option').remove();
    if (!calData || !calData.length) {
      this.launchSelErrOverlay();
      this.artContainer.hide();
    } else if (calData.length <= 1) {
      this.artContainer.hide();
    } else {
      for (var i = 0, len = calData.length; i < len; i += 1) {
        var optionText = calData[i].public_name,
          optionValue = calData[i].id,
          optionDisplay =
            typeof calData[i].artist_selectable_online !== 'undefined'
              ? parseInt(calData[i].artist_selectable_online)
              : 1,
          isChairMode = typeof calData[i].chair_mode !== 'undefined' ? parseInt(calData[i].chair_mode) : 1,
          newOption;

        if (optionDisplay && !isChairMode) {
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');

          if (optionValue === this.calendarId) {
            newOption.attr('selected', 'selected');
          }

          this.artSelect.append(newOption);
        }
      }

      var artSelectLength = this.artSelect.find('option');

      if (artSelectLength.length <= 1) {
        this.artContainer.hide();
      }

      me.container.find('.selectbox').each(function () {
        $(this).trigger('select.enabled');
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildApptSelect = function () {
    var mOptions,
      vOptions,
      dpOptions,
      calDate,
      calTable,
      calHead,
      cHCont,
      colHeads,
      timeSlotsContainer,
      timeSlotRow,
      monthNames,
      dayNames,
      slotLabels,
      dpTrigger,
      dpField,
      dpOverlay,
      dpCalCont,
      dpCloseBtn,
      dp,
      dpMonthNames,
      dpDayNames,
      CalHeadView,
      CalTimeSlotsView,
      CalDatePicker,
      totText,
      dpYearSuffix;
    var me = this;
    var bookBtn = this.bookBar.find('#appt-book-book-submit').off('click');

    if (!site.client.isMobile) {
      calTable = this.apptContainer.find('.weekdays');
      calHead = this.apptContainer.find('.calendar-head');
      cHCont = calTable.find('thead.col-heads');
      colHeads = cHCont.find('th');
      timeSlotsContainer = calTable.find('tbody.timeslots');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      dateFormat = cHCont.attr('data-date-format');
      monthNames = cHCont.attr('data-months').split(',');
      dayNames = cHCont.attr('data-days').split(',');
      slotLabels = cHCont.attr('data-time-slots').split(',');
      closedCopy = cHCont.attr('data-closed-copy') || 'closed';
      dpTrigger = calHead.find('#appt-book-date-picker-trigger');
      dpField = calHead.find('#appt-book-date-picker-field');
      dpOverlay = this.container.find('#appt-book-datepicker-overlay').remove();
      dpCalCont = dpOverlay.find('#appt-book-datepicker-calendar-container');
      dpCloseBtn = dpOverlay.find('.overlay-close');
      dpMonthNames = dpTrigger.attr('data-months').split(',');
      dpDayNames = dpTrigger.attr('data-days').split(',');
      dpYearSuffix = calHead.attr('data-year-suffix');
      // move sunday label to last position of oab starts from monday
      if (oab_start_from_monday) {
        dpDayNames.push(dpDayNames.shift());
      }
      CalHeadView = apptBook.CalendarHeader;
      CalTimeSlotsView = apptBook.CalendarTimeSlots;
      CalDatePicker = apptBook.CalDatePicker;

      vOptions = {
        container: this.apptContainer,
        interval: this.slotInterval,
        colHeads: colHeads,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        dateFormat: dateFormat,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels,
        closedCopy: closedCopy
      };

      dpOptions = {
        overlay: dpOverlay,
        closeBtn: dpCloseBtn,
        calContainer: dpCalCont,
        weekContainer: calHead,
        datepickerField: dpField,
        datepickerTrigger: dpTrigger,
        dateFormat: dateFormat,
        monthNames: dpMonthNames,
        dayNames: dpDayNames,
        yearSuffix: dpYearSuffix,
        jqBod: calHead
      };
    } else {
      dpOverlay = this.container.find('#appt-book-datepicker-overlay').prependTo(this.jqBod);
      timeSlotsContainer = dpOverlay.find('table.day'); // replace parent
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      slotLabels = timeSlotsContainer.attr('data-time-slots').split(',');
      closedCopy = timeSlotsContainer.attr('data-closed-copy') || 'closed';
      calHead = this.apptContainer.find('.calendar-head');
      dpTrigger = calHead.find('#appt-book-date-picker-trigger');
      dp = dpOverlay.find('.date-picker'); // replace parent
      dpField = dpOverlay.find('#appt-book-date-picker-field'); // replace parent
      dpCont = dpOverlay.find('.date-picker-container'); // replace parent
      dpCalCont = dpOverlay.find('#appt-book-datepicker-calendar-container'); // replace parent
      dpCloseBtn = dpCont.find('.date-picker-close');
      dpMonthNames = dp.attr('data-months').split(',');
      dpDayNames = dp.attr('data-days').split(',');
      dpYearSuffix = calHead.attr('data-year-suffix');
      CalHeadView = apptBook.CalendarHeaderMobile;
      CalTimeSlotsView = apptBook.CalendarTimeSlotsMobile;
      CalDatePicker = apptBook.CalDatePickerMobile;
      dpOverlay.remove();

      vOptions = {
        container: this.apptContainer,
        interval: this.slotInterval,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels,
        closedCopy: closedCopy
      };

      dpOptions = {
        overlay: dpOverlay,
        container: dpCont,
        closeBtn: dpCloseBtn,
        calContainer: dpCalCont,
        datepickerField: dpField,
        datepickerTrigger: dpTrigger,
        monthNames: dpMonthNames,
        dayNames: dpDayNames,
        yearSuffix: dpYearSuffix,
        jqBod: this.jqBod
      };
    }

    mOptions = {
      dataModel: this.model,
      launchOverlayCallback: this.launchSelErrOverlay.bind(this),
      datepickerContainer: dpCalCont,
      counterId: this.counterId,
      appointmentDuration: this.totalTime,
      appointmentDurationWithPadding: this.apptDurWithPadding,
      timeSlotsContainer: timeSlotsContainer,
      appointmentPrice: this.totalPrice,
      serviceIds: this.serviceIds
    };

    this.calModel = new apptBook.CalendarModel();
    this.calModel.setData(mOptions);
    this.calTimeSlots = new CalTimeSlotsView(vOptions);
    this.calHeadView = new CalHeadView(calHead);
    this.calTimeSlots.setModel(this.calModel).startObserving();
    this.calHeadView.setModel(this.calModel).startObserving();

    this.datePicker = new CalDatePicker(dpOptions);
    this.datePicker.setModel(this.calModel);

    this.artSelect.on('change', function (e) {
      var calId = this.value,
        calName = this.options[this.selectedIndex].text;

      if (calId !== me.calendarId) {
        me.calModel.update({
          calendarId: calId,
          apptDur: me.totalTime,
          apptDurWithPadding: me.totalTimeWithPadding
        });
        me.calendarId = calId;
      }
    });

    calDate = this.appointmentTime ? dateUtils.convertTimeString(this.appointmentTime) : new Date();
    var openTimes = me.counterData.opening_time_range;

    this.calModel.update({
      date: calDate,
      hilite: true,
      calendarId: this.calendarId,
      apptDur: this.totalTime,
      apptDurWithPadding: this.apptDurWithPadding,
      appointmentTime: this.appointmentTime,
      openTimes: openTimes,
      showNextWeek: true
    });

    totText = this.totalText + ' ' + this.totalTime + ' ' + this.minLabel;
    this.totalElem.html(totText);

    this.startOver.off('click');
    this.startOver.click(function () {});

    this.calModel.on('time_selected', function (data) {
      bookBtn.removeClass('disabled');
      dpCloseBtn.trigger('click');
    });

    this.calModel.on('time_deselected', function (data) {
      bookBtn.addClass('disabled');
    });

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        updateData,
        $this = $(this),
        isArray = me.serviceIds instanceof Array;

      if ($this.hasClass('disabled')) {
        return;
      }
      $this.addClass('disabled');

      params = {
        counterId: me.counterId,
        calendarId: me.calendarId,
        serviceIds: me.serviceIds,
        services: me.servicesData,
        appointmentId: me.appointmentId,
        startTime: me.calModel.getSelection().selectionString
      };

      site?.track?.evtLink && site.track.evtLink({
        event_name: 'appointmentBooking_DateTime',
        event_category: 'appointment booking',
        event_action: 'Date and Time Picked',
        event_label: me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.startTime
      });

      updateData = {
        sectionId: 'next',
        params: params
      };
      function onBookSuccess(r) {
        var updateData,
          apptId = r.id;

        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        $this.addClass('disabled');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        if (r.code === 500 || r.code === '500') {
          me.launchBookConflictOverlay();

          return;
        }
      }

      function doBooking() {
        me.model.update(updateData);
        $this.addClass('disabled');
      }
      doBooking();
    }
  };

  apptBook.AppointmentSelectSection.prototype.launchSelErrOverlay = function () {
    var me = this;

    if (me.overlayIsOpen) {
      return;
    }
    me.overlayIsOpen = true;
    this.jqBod.prepend(this.selErrOverlay);
    this.selErrOverlay.show();
    this.selErrOverlay.click(function (e) {
      e.preventDefault();
      var upObj = {
        sectionId: 'services',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(upObj);
      me.selErrOverlay.off('click');
      me.selErrOverlay.remove();
      me.overlayIsOpen = false;
    });
  };

  apptBook.AppointmentSelectSection.prototype.launchBookConflictOverlay = function () {
    var me = this,
      selDate = this.calModel.getSelection().selectionDate;

    this.jqBod.prepend(this.bookConflictOverlay);
    this.calModel.update({ date: selDate });
    this.bookConflictOverlay.show();
    this.bookConflictOverlay.click(function (e) {
      e.preventDefault();
      me.bookConflictOverlay.off('click');
      me.bookConflictOverlay.remove();
    });
  };

  apptBook.AppointmentSelectSection.prototype.removeService = function (service) {
    var me = this;
    var upObj = {};

    upObj = {
      sectionId: 'services',
      params: {
        sectionId: me.id,
        counterId: me.counterId,
        serviceIds: me.serviceIds,
        updateMode: me.updateMode,
        dateSet: false
      }
    };
    me.model.update(upObj);
  };

  apptBook.AppointmentSelectSection.prototype.launchLocationConflictOverlay = function (maxDuration) {
    var me = this;

    this.jqBod.prepend(this.locationConflictOverlay);
    me.locationConflictOverlay.find('span.max_duration').text(maxDuration);
    this.locationConflictOverlay.show();
    this.locationConflictOverlay.click(function (e) {
      e.preventDefault();
      me.locationConflictOverlay.off('click');
      me.locationConflictOverlay.remove();
    });
  };

  /* *
   *
   * Appointments Time Slot Selector Calendar and Mobile Calendar
   * This is a set of Classes that create objects that are the members of an MVC Calendar that displays and allows
   * selection of the available time slots of calendars coming from the API.
   *
   *
   *
   * */

  /**
   * CalendarModel
   * This is the model. It controls the calendars state and main logic.
   * It broadcasts updates to registered views and controllers
   *
   */

  apptBook.CalendarModel = function () {
    apptBook.CalendarModel.superclass.constructor.call(this);
    this.dataSet = false;
    this.dateSet = false;
    this.isDateSelected = false;
    this.container = $('body').find('#appointment-book-container');
    this.winPos = $(window).scrollTop();
  };

  // CalendarModel is a Publisher in a Publisher Subscriber (event listening) pattern.
  ctrlopt.extend(apptBook.CalendarModel, ctrlopt.Publisher);

  apptBook.CalendarModel.prototype.setData = function (options) {
    if (this.dataSet) {
      return;
    }
    this.dataSet = true;
    this.calData = {};
    this.dataModel = options.dataModel;
    this.launchOverlay = options.launchOverlayCallback;
    this.datepickerContainer = options.datepickerContainer;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.counterId = options.counterId;
    this.calendarId = 0;
    this.apptDur = options.appointmentDuration;
    this.apptDurWithPadding = options.appointmentDurationWithPadding;
    this.serviceIds = options.serviceIds;
  };

  apptBook.CalendarModel.prototype.update = function (data) {
    if (!this.dataSet || !data) {
      return;
    }
    var me = this;

    this.calData.hilite = data.hilite ? true : false;
    this.calData.apptDur = data.apptDur;
    this.calData.apptDurWithPadding = data.apptDurWithPadding;
    this.calData.currentDate = this.calData.currentDate || new Date();
    this.calData.myDate = data.date || this.calData.myDate || this.calData.currentDate;
    this.calData.showNextWeek = true;
    this.calendarId = data.calendarId || this.calendarId;
    this.counterId = data.counterId || this.counterId;
    this.serviceIds = data.serviceIds || this.serviceIds;
    this.calData.apptTime = data.appointmentTime;
    this.calData.openTimes = data.openTimes || this.calData.openTimes;
    this.calData.datesInvalid = data.datesInvalid || this.calData.datesInvalid || [];
    if (typeof data.timeSlotInterval != 'undefined') {
      this.calData.timeSlotInterval = data.timeSlotInterval;
    }
    if (typeof data.dateSet != 'undefined') {
      this.dateSet = data.dateSet;
    }
    this.dataModel.getCounter(this.counterId, { service_id: this.serviceIds }, function (countData) {
      var cal,
        cals = countData.calendars;

      if (!cals || !cals.length) {
        me.calData.timeslots = null;
        if (me.launchOverlay && typeof me.launchOverlay === 'function') {
          me.launchOverlay();
        }
      } else {
        for (var i = 0, len = cals.length; i < len; i += 1) {
          cal = cals[i];
          if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
            me.calData.timeslots = cal.timeslots;
            break;
          }
        }

        // If NO timeslots fall on a given day, it will never be marked invalid
        // Since we are removing dates from datesInvalid when they are valid, just initialize datesInvalid array with every day
        var myDay = new Date();
        var daysToSet = 60;

        while (daysToSet > 0) {
          me.calData.datesInvalid.push(dateUtils.dateToString(myDay, 'yyyy-mm-dd'));
          myDay.setDate(myDay.getDate() + 1);
          daysToSet -= 1;
        }

        // Get the invalid Dates with range times minors than the Appt Duration
        for (var i = 0, len = me.calData.timeslots.length; i < len; i += 1) {
          var range = me.calData.timeslots[i],
            start = dateUtils.convertTimeString(range.start_date),
            end = dateUtils.convertTimeString(range.end_date);

          timeLeft = end.getTime() - start.getTime();
          minLeft = Math.floor(timeLeft / 60000);
          dateKey = dateUtils.dateToString(start, 'yyyy-mm-dd');
          if (minLeft < me.calData.apptDur) {
            if ($.inArray(dateKey, me.calData.datesInvalid) == -1) {
              me.calData.datesInvalid.push(dateKey);
            }
          } else {
            me.calData.datesInvalid = $.grep(me.calData.datesInvalid, function (value) {
              return value != dateKey;
            });
          }
        }
      }

      if (!me.dateSet) {
        me.fire('time_deselected');
      }
      me.dispatchUpdate(me.calData);
    });
  };

  apptBook.CalendarModel.prototype.dispatchUpdate = function (data) {
    this.fire('update', data);
  };

  apptBook.CalendarModel.prototype.getData = function () {
    return this.dataSet ? this.calData : null;
  };

  apptBook.CalendarModel.prototype.setSelection = function (selection, me) {
    this.selection = selection;
    this.selectionString =
      selection.getFullYear() +
      '-' +
      (selection.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      selection.getDate().toString().padStart(2, '0') +
      ' ' +
      selection.getHours().toString().padStart(2, '0') +
      ':' +
      ('0' + selection.getMinutes()).slice(-2) +
      ':00';

    if (site.client.isMobile) {
      if (me.model) {
        $(window).scrollTop(me.model.winPos);
        me.model.headContent.removeClass('hidden');
        me.model.hDefContent.addClass('hidden');
        me.model.update({
          date: selection,
          hilite: true,
          apptDur: me.model.apptDur,
          apptDurWithPadding: me.model.apptDurWithPadding
        });
        me.model.dateSet = true;
      }
    }

    this.fire('time_selected', this.selectionString);
  };

  apptBook.CalendarModel.prototype.getSelection = function () {
    return {
      selectionDate: this.selection,
      selectionString: this.selectionString
    };
  };

  /**
   * CalendarHeader is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeader = function (header) {
    apptBook.CalendarHeader.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.rArrow = this.header.find('.next');
    this.lArrow = this.header.find('.previous');
    this.dayStates = this.header.find('.day-time');
    this.morning = this.dayStates.find('.morning');
    this.afternoon = this.dayStates.find('.afternoon');
    this.evening = this.dayStates.find('.evening');
    this.headContent = this.header.find('.cal-copy');
    this.headCopy = this.headContent.html();
    this.months = this.header.attr('data-months').split(',');
  };

  ctrlopt.extend(apptBook.CalendarHeader, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeader.prototype.defaultController = function () {
    return this.controller;
  };

  apptBook.CalendarHeader.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      headOutIni,
      headOutEnd,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay()),
      now = new Date(),
      nowDay = startDayShift(now.getDay());

    now.setDate(now.getDate() - nowDay);

    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0, 0, 0, 0);

    this.lastDay = new Date(this.firstDay.getTime());
    this.lastDay.setDate(this.lastDay.getDate() + 6);
    this.lastDay.setHours(23, 59, 59, 999);

    var findTimeSlotAvailableStatus = me.model.timeSlotsContainer.find('td').filter('.enabled').first();
    var findWrapperCalendar = me.model.timeSlotsContainer.closest('.weekdays');
    var slotCalendarView = findWrapperCalendar.hasClass('calendar-view');
    var verifyNoSlotAvailable = findWrapperCalendar.next('.js-calendar-wrapper-no-slot');
    var nextCalendarDate = new Date(me.firstDay.getTime());

    if (this.firstDay > now) {
      this.lArrow.css('visibility', 'visible');
    } else {
      this.lArrow.css('visibility', 'hidden');
    }

    // test if store is closed in morning/afternoon/evening on the selected day
    // fetch a hash of open states
    var openStates = this.getStoreOpenStates(this.calData.myDate, this.calData.openTimes);

    for (var dayPart in openStates) {
      this[dayPart].removeClass('store_closed');
      if (!openStates[dayPart]) {
        // add css class if store is closed for that day part
        this[dayPart].addClass('store_closed');
      }
    }
    if (kr_day_month_format) {
      headOut =
        this.firstDay.getFullYear() +
        this.header.data('year-suffix') +
        ' ' +
        this.months[this.firstDay.getMonth()] +
        this.header.data('month-suffix') +
        ' ' +
        this.firstDay.getDate() +
        this.header.data('day-suffix') +
        ' ' +
        this.headCopy;
    } else if (oab_date_format_jp) {
      headOut =
        this.firstDay.getFullYear() +
        oab_year_suffix +
        ' ' +
        this.months[this.firstDay.getMonth()] +
        oab_month_suffix +
        ' ' +
        this.firstDay.getDate() +
        oab_day_suffix +
        this.headCopy;
    } else {
      headOut = oab_cal_header_tmpl;
      headOut = headOut.replace('[weekof]', this.headCopy);
      headOut = headOut.replace('[d]', this.firstDay.getDate());
      headOut = headOut.replace('[m]', this.months[this.firstDay.getMonth()]);
      headOut = headOut.replace('[y]', this.firstDay.getFullYear());
      headOut = headOut.replace('[ys]', oab_year_suffix);
      headOut = headOut.replace('[ms]', oab_month_suffix);
      headOut = headOut.replace('[ds]', oab_day_suffix);
    }
    this.headContent.html(headOut);
    // default "book through" to next month
    thru_month = this.firstDay.getMonth() == 11 ? 0 : this.firstDay.getMonth() + 1;
    month_names = $('#appt-book-date-picker-trigger[data-months]').attr('data-months').split(',');
    $('.js-thru_month').html(month_names[thru_month]);

    if (site.client.isMobile) {
      if (!this.model.dateSet) {
        if (me.hDefContent) {
          me.hDefContent.removeClass('hidden');
        }
        if (me.headContent) {
          me.headContent.addClass('hidden');
        }
      } else {
        if (me.hDefContent) {
          me.hDefContent.addClass('hidden');
        }
        if (me.headContent) {
          me.headContent.removeClass('hidden');
        }
      }
    }

    this.lArrow.off('click');
    this.rArrow.off('click');
    this.morning.off('click');
    this.afternoon.off('click');
    this.evening.off('click');

    this.rArrow.css('cursor', 'pointer').click(function (e) {
      e.preventDefault();
      var nextDate = new Date(me.firstDay.getTime());

      nextDate.setDate(nextDate.getDate() + 7);
      me.model.isDateSelected = false;

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({
        date: nextDate,
        apptDur: me.model.calData.apptDur,
        apptDurWithPadding: me.model.calData.apptDurWithPadding
      });
      data.showNextWeek = false;
    });

    this.lArrow.css('cursor', 'pointer').click(function (e) {
      e.preventDefault();
      var prevDate = new Date(me.firstDay.getTime());

      prevDate.setDate(prevDate.getDate() - 7);
      me.model.isDateSelected = false;

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({
        date: prevDate,
        apptDur: me.model.calData.apptDur,
        apptDurWithPadding: me.model.calData.apptDurWithPadding
      });
      data.showNextWeek = false;
    });

    this.scrollToTime = function (time, selector) {
      var $tCell = $("td[data-hour='" + time + "']");
      var $tRow = $tCell.parent();
      var scrollTarget = $('.weekdays .col-heads').height() + $tRow.height() * $tRow.index();

      me.dayStates.find('.selected').removeClass('selected');
      selector.addClass('selected');
      $('tbody.timeslots').animate(
        {
          scrollTop: scrollTarget
        },
        1000
      );
    };

    if (!me.initialized) {
      this.scrollToTime('12:00', $(this.afternoon));
    }

    if (!!openStates.morning) {
      this.morning.css('cursor', 'pointer').click(function (e) {
        e.preventDefault();
        var date = new Date(me.firstDay.getTime());

        me.header.parent().attr('data-day-status', 'morning');
        me.scrollToTime('9:00', $(this));
      });
    }
    if (!!openStates.afternoon) {
      this.afternoon.css('cursor', 'pointer').click(function (e) {
        e.preventDefault();
        var date = new Date(me.firstDay.getTime());

        me.header.parent().attr('data-day-status', 'afternoon');
        me.scrollToTime('12:00', $(this));
      });
    }
    if (!!openStates.evening) {
      this.evening.css('cursor', 'pointer').click(function (e) {
        e.preventDefault();
        var date = new Date(me.firstDay.getTime());

        me.header.parent().attr('data-day-status', 'evening');
        me.scrollToTime('16:00', $(this));
      });
    }
    if (!findTimeSlotAvailableStatus.length && slotCalendarView && me.firstDay < now && data.showNextWeek) {
      nextCalendarDate.setDate(nextCalendarDate.getDate() + 7);
      me.model.isDateSelected = false;
      me.model.update({
        date: nextCalendarDate,
        apptDur: me.model.calData.apptDur
      });
    }
    if (!findTimeSlotAvailableStatus.length && slotCalendarView) {
      verifyNoSlotAvailable.removeClass('hidden');
    } else {
      verifyNoSlotAvailable.addClass('hidden');
    }
  };

  /**
   * CalendarTimeSlots is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param thisDate Date required
   * @param openTimes Object required
   * @returns Object example: { morning: true, afternoon: false, evening: true }
   */
  apptBook.CalendarHeader.prototype.getStoreOpenStates = function (thisDate, openTimes) {
    var returnObj = {
      morning: false,
      afternoon: false,
      evening: false
    };
    var startMorningStr = '9:00';
    var endMorningStr = '11:45';
    var startAfternoonStr = '12:00';
    var endAfternoonStr = '15:45';
    var startEveningStr = '16:00';
    var endEveningStr = '20:00';
    var mergeDateTime = function (thisDate, timeStr) {
      var returnDate = new Date(thisDate);

      returnDate.setHours(timeStr.split(':')[0]);
      returnDate.setMinutes(timeStr.split(':')[1]);

      return returnDate;
    };
    var startMorningDate = mergeDateTime(thisDate, startMorningStr);
    var endMorningDate = mergeDateTime(thisDate, endMorningStr);
    var startAfternoonDate = mergeDateTime(thisDate, startAfternoonStr);
    var endAfternoonDate = mergeDateTime(thisDate, endAfternoonStr);
    var startEveningDate = mergeDateTime(thisDate, startEveningStr);
    var endEveningDate = mergeDateTime(thisDate, endEveningStr);
    var dayPartRanges = {
      morning: [startMorningDate, endMorningDate],
      afternoon: [startAfternoonDate, endAfternoonDate],
      evening: [startEveningDate, endEveningDate]
    };
    var openTimesDateKey = dateUtils.dateToString(thisDate, 'yyyy-mm-dd');

    if (!openTimes[openTimesDateKey]) {
      return returnObj;
    }
    // iterate over open sessions for that day
    for (var i = 0, len = openTimes[openTimesDateKey].length; i < len; i++) {
      // munge date strings to work with conversion method
      var startOpenStr = openTimesDateKey + ' ' + openTimes[openTimesDateKey][i]['start_time'] + ':00';
      var endOpenStr = openTimesDateKey + ' ' + openTimes[openTimesDateKey][i]['end_time'] + ':00';
      // get Date objects for the open & close times
      var startOpenDate = dateUtils.convertTimeString(startOpenStr);
      var endOpenDate = dateUtils.convertTimeString(endOpenStr);
      // create an array to represent this "open time" range
      var openRange = [startOpenDate, endOpenDate];

      // iterate over day parts
      for (var dayPart in dayPartRanges) {
        // if we've already found an open time for this day part, skip to next day part
        if (!!returnObj[dayPart]) {
          continue;
        }
        // if they overlap, set return value to true for this day part
        if (dateUtils.compareRanges(dayPartRanges[dayPart], openRange)) {
          returnObj[dayPart] = true;
          // skip to next day part
          continue;
        }
      } // end iterate over day parts
    } // end iterate over open sessions

    return returnObj;
  };

  /**
   * CalendarTimeSlots is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlots = function (options) {
    apptBook.CalendarTimeSlots.superclass.constructor.call(this);
    this.initialized = false;
    this.container = options.container;
    this.colHeads = options.colHeads;
    this.timeSlotRow = options.timeSlotRow;
    this.timeSlotInterval = options.interval;
    this.timeContainer = options.timeContainer;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.days = options.dayNames;
    this.dateFormat = options.dateFormat || '';
    this.months = options.monthNames;
    this.slotLabels = options.slotLabels;
    this.closedCopy = options.closedCopy;

    this.slots = [
      { hour: '7:00' },
      { hour: '7:15' },
      { hour: '7:30' },
      { hour: '7:45' },
      { hour: '8:00' },
      { hour: '8:15' },
      { hour: '8:30' },
      { hour: '8:45' },
      { hour: '9:00' },
      { hour: '9:15' },
      { hour: '9:30' },
      { hour: '9:45' },
      { hour: '10:00' },
      { hour: '10:15' },
      { hour: '10:30' },
      { hour: '10:45' },
      { hour: '11:00' },
      { hour: '11:15' },
      { hour: '11:30' },
      { hour: '11:45' },
      { hour: '12:00' },
      { hour: '12:15' },
      { hour: '12:30' },
      { hour: '12:45' },
      { hour: '13:00' },
      { hour: '13:15' },
      { hour: '13:30' },
      { hour: '13:45' },
      { hour: '14:00' },
      { hour: '14:15' },
      { hour: '14:30' },
      { hour: '14:45' },
      { hour: '15:00' },
      { hour: '15:15' },
      { hour: '15:30' },
      { hour: '15:45' },
      { hour: '16:00' },
      { hour: '16:15' },
      { hour: '16:30' },
      { hour: '16:45' },
      { hour: '17:00' },
      { hour: '17:15' },
      { hour: '17:30' },
      { hour: '17:45' },
      { hour: '18:00' },
      { hour: '18:15' },
      { hour: '18:30' },
      { hour: '18:45' },
      { hour: '19:00' },
      { hour: '19:15' },
      { hour: '19:30' },
      { hour: '19:45' },
      { hour: '20:00' },
      { hour: '20:15' },
      { hour: '20:30' },
      { hour: '20:45' },
      { hour: '21:00' },
      { hour: '21:15' },
      { hour: '21:30' },
      { hour: '21:45' }
    ];

    for (var i = 0, len = this.slots.length; i < len; i += 1) {
      if (this.slotLabels && this.slotLabels[i]) {
        this.slots[i].label = this.slotLabels[i];
      } else {
        this.slots[i].label = ' ';
      }
    }
  };

  ctrlopt.extend(apptBook.CalendarTimeSlots, ctrlopt.mvc.AbstractView);

  apptBook.CalendarTimeSlots.prototype.defaultController = function (data) {
    return null;
  };

  apptBook.CalendarTimeSlots.prototype.onUpdate = function (data) {
    this.calData = data;
    this.buildWeekView();
  };

  apptBook.CalendarTimeSlots.prototype.buildWeekView = function () {
    var hText,
      sText,
      hour,
      row,
      len = 7,
      endViMorning = '11:45',
      startViAfternoon = '12:00',
      endViAfternoon = '17:45',
      startViEvening = '18:00',
      startvi = 0,
      startviH = 0,
      startviM = 0,
      endVi = 0,
      endViH = 0,
      endViM = 0,
      t1,
      t2,
      ti,
      parts,
      stateofDay = this.container.attr('data-day-status'),
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay());
    var me = this;

    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0, 0, 0, 0);
    this.lastDay = new Date(this.firstDay.getTime());
    this.lastDay.setDate(this.lastDay.getDate() + 6);
    this.lastDay.setHours(23, 59, 59, 999);
    this.openTimes = this.calData.openTimes;
    if (typeof this.calData.timeSlotInterval != 'undefined') {
      this.timeSlotInterval = this.calData.timeSlotInterval;
    }

    t1 = new Date(); // Start Time Slot
    t2 = new Date(); // End Time Slot
    ti = new Date(); // Current Time Slot

    if (this.calData.apptTime) {
      var apptTime = dateUtils.convertTimeString(this.calData.apptTime),
        apptHour = apptTime.getHours();

      if (apptHour >= startViAfternoon.split(':')[0]) {
        stateofDay = 'afternoon';
      } else if (apptHour >= startViEvening.split(':')[0]) {
        stateofDay = 'evening';
      } else {
        stateofDay = 'morning';
      }
      this.container.attr('data-day-status', stateofDay);
    }

    if (stateofDay == 'morning') {
      startVi = this.firstDay.getHours() + ':' + this.firstDay.getMinutes();
      startViH = this.firstDay.getHours();
      startViM = this.firstDay.getMinutes();
      endVi = endViMorning;
      endViH = endVi.split(':')[0];
      endViM = ('0' + endVi.split(':')[1]).slice(-2);
    } else if (stateofDay == 'afternoon') {
      startVi = startViAfternoon;
      startViH = startVi.split(':')[0];
      startViM = ('0' + startVi.split(':')[1]).slice(-2);
      endVi = endViAfternoon;
      endViH = endVi.split(':')[0];
      endViM = ('0' + endVi.split(':')[1]).slice(-2);
    } else if (stateofDay == 'evening') {
      startViH = startViEvening.split(':')[0];
      startViM = ('0' + startViEvening.split(':')[1]).slice(-2);
      endVi = this.lastDay.getHours() + ':' + this.lastDay.getMinutes();
      endViH = this.lastDay.getHours();
      endViM = this.lastDay.getMinutes();
    } else {
      startViH = this.firstDay.getHours();
      startViM = ('0' + this.firstDay.getMinutes()).slice(-2);
      endViH = this.lastDay.getHours();
      endViM = this.lastDay.getMinutes();
    }

    t1.setHours(startViH, startViM, 0, 0);
    t2.setHours(endViH, endViM, 0, 0);

    var i;

    for (i = 0; i < len; i += 1) {
      var myDayDate = new Date(this.firstDay.getTime());

      myDayDate.setDate(myDayDate.getDate() + i);
      if (kr_day_month_format) {
        hText = this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate() + ' ' + this.days[i];
      } else if (this.dateFormat == 'ddmm') {
        if (oab_date_format_with_dot) {
          hText = this.days[i] + ', ' + myDayDate.getDate() + '.' + this.months[myDayDate.getMonth()] + '.';
        } else {
          hText = this.days[i] + ' ' + myDayDate.getDate() + '/' + this.months[myDayDate.getMonth()];
        }
      } else if (oab_date_format_jp) {
        hText = this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate() + this.days[i];
      } else {
        hText = this.days[i] + ' ' + this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate();
      }
      this.colHeads.eq(i).removeClass('hilite').text(hText);
    }

    if (this.calData.hilite) {
      this.colHeads.eq(dayOfWeek).addClass('hilite');
    }

    var intervalFactor = this.timeSlotInterval / 15;

    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    this.timeSlotsContainer.empty();
    len = this.slots.length;

    // build an array of each day displayed on the calendar
    this.calendarDays = [this.firstDay];
    var oneDay = 24 * 60 * 60 * 1000;

    for (var i = 0; i < 7; i++) {
      var prevDay = this.calendarDays[i];
      var nextDay = new Date(prevDay.getTime() + oneDay);

      this.calendarDays.push(nextDay);
    }

    for (var i = 0; i < len; i += intervalFactor) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      parts = hour.split(':');
      ti.setHours(parts[0], parts[1], 0, 0);
      row = this.timeSlotRow.clone();
      var thisDay = new Date(this.calendarDays[i]);

      row
        .find('td')

        .attr('data-hour', hour)
        .text(sText)
        .css('display', 'table-cell')
        .each(function (idx) {
          var myDateTime = me.calendarDays[idx];

          myDateTime.setHours(parts[0], parts[1], 0, 0);

          var to = new Date(myDateTime.getTime()); // Open Store Time Slot
          var tc = new Date(myDateTime.getTime()); // Close Store Time Slot
          var openTimesDateKey = dateUtils.dateToString(myDateTime, 'yyyy-mm-dd');

          if (typeof me.openTimes[openTimesDateKey] !== 'undefined' && me.openTimes[openTimesDateKey].length) {
            // loop through all available openTimesDateKey keys since there may multiple start and end times for a given day
            var slot_is_available = false;

            for (var i = 0; i < me.openTimes[openTimesDateKey].length; i++) {
              // get HH:mm:ss string for the open & close times
              var openStoreHourStr = me.openTimes[openTimesDateKey][i]['start_time'].split(':');
              var closeStoreHourStr = me.openTimes[openTimesDateKey][i]['end_time'].split(':');

              // get Date objects for the open & close times
              to.setHours(openStoreHourStr[0], openStoreHourStr[1], 0, 0);
              tc.setHours(closeStoreHourStr[0], closeStoreHourStr[1], 0, 0);
              if (myDateTime.getTime() >= to.getTime() && myDateTime.getTime() < tc.getTime()) {
                slot_is_available = true;
              }
            }
            if (!slot_is_available) {
              $(this).text(me.closedCopy); // Set this time slot as Closed.
            }
          }
          $(this).attr({
            'data-date-time': myDateTime,
            'aria-label': myDateTime
          });
        });
      this.timeSlotsContainer.append(row);
    }
    this.timeSlotsElems = this.timeSlotsContainer.find('td');
    this.setSlots();
    if (this.calData.apptTime) {
      this.setApptTime();
    }
    if (this.calData.openTimes) {
      this.handleStoreOpenTimes();
    }
  };

  //
  // This function compares the dates on the calendar to the times that the store is open
  // and sets class names on the time slots accordingly
  apptBook.CalendarTimeSlots.prototype.handleStoreOpenTimes = function () {
    var me = this;

    this.timeSlotsElems.each(function (idx, ele) {
      $td = $(this);
      var slotDateTimeStr = $td.attr('data-date-time');

      slotDateTime = new Date(slotDateTimeStr);
      // build key from date values
      var openTimesDateKey = dateUtils.dateToString(slotDateTime, 'yyyy-mm-dd');
      // use that key to look up store-open times for that day
      var openTimes = me.calData.openTimes;

      if (openTimes[openTimesDateKey]) {
        // iterate over open sessions for that day
        for (var j = 0, jlen = openTimes[openTimesDateKey].length; j < jlen; j++) {
          var storeIsOpen = false;
          // munge date strings to work with conversion method
          var startOpenStr = openTimesDateKey + ' ' + openTimes[openTimesDateKey][j]['start_time'] + ':00';
          var endOpenStr = openTimesDateKey + ' ' + openTimes[openTimesDateKey][j]['end_time'] + ':00';
          // get Date objects for the open & close times
          var startOpenDate = dateUtils.convertTimeString(startOpenStr);
          var endOpenDate = dateUtils.convertTimeString(endOpenStr);

          // add class name if this slot's time is within an open time range
          if (dateUtils.inRange(slotDateTime, startOpenDate, endOpenDate)) {
            $td.addClass('store_open');
          }
        }
      }
    }); // end this.timeSlotsElems.each
  };

  apptBook.CalendarTimeSlots.prototype.processSlot = function (start, end, interval) {
    var startIndex = 0,
      myDay = new Date(start.getTime()),
      myDayOfWeek = startDayShift(myDay.getDay()),
      todayDate = new Date(),
      stateofDay = this.container.attr('data-day-status'),
      col = this.timeSlotsContainer.find('.day-' + myDayOfWeek);

    interval = interval ? interval : 60;
    var dMinute = Math.ceil(start.getMinutes() / interval),
      startHour = dMinute * interval === 60 ? start.getHours() + 1 : start.getHours(),
      startMin = dMinute * interval === 0 || dMinute * interval === 60 ? '00' : dMinute * interval,
      startTime = startHour + ':' + startMin,
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this;
    var intervalFactor = this.timeSlotInterval / 15;

    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    for (var i = 0; i < len; i += intervalFactor) {
      if (this.slots[i].hour === startTime) {
        startIndex = i;
        break;
      }
    }

    for (var i = startIndex; i < len; i += intervalFactor) {
      var timeLeft,
        minLeft,
        sT = this.slots[i].hour.split(':');

      sHrDate.setHours(sT[0], sT[1], 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDurWithPadding) {
        break;
      } else {
        col
          .eq(parseInt(i / intervalFactor))
          .attr('tabindex', '0')
          .addClass('enabled')
          .click(function (e) {
            var slotDate = new Date(start.getTime()),
              hour,
              min,
              $this = $(this);

            me.timeSlotsElems.removeClass('selected');
            $this.addClass('selected');
            hour = $this.attr('data-hour').split(':')[0];
            min = $this.attr('data-hour').split(':')[1];
            slotDate.setHours(parseInt(hour, 10));
            slotDate.setMinutes(parseInt(min));
            me.model.setSelection(slotDate, me);
          });
        col
          .eq(parseInt(i / intervalFactor))
          .attr({
            tabindex: '0',
            role: 'menu'
          })
          .addClass('enabled')
          .keyup(function (e) {
            var bookBtn = $('.book-now-bar').find('#appt-book-book-submit');

            if ($(this).hasClass('custom-outline')) {
              $(this).removeClass('custom-outline');
            }
            switch (site.getKeycode(e)) {
              case 39: // right arrow
                $(this).closest('td').next().addClass('custom-outline').focus();
                break;
              case 37: // left arrow
                $(this).closest('td').prev().addClass('custom-outline').focus();
                break;
              case 40: // down arrow
                $(this)
                  .closest('tr')
                  .next()
                  .find('td:eq(' + $(this).closest('td').index() + ')')
                  .addClass('custom-outline')
                  .focus();
                break;
              case 38: // up arrow
                $(this)
                  .closest('tr')
                  .prev()
                  .find('td:eq(' + $(this).closest('td').index() + ')')
                  .addClass('custom-outline')
                  .focus();
                break;
              case 13:
                $(this).trigger('click');
                bookBtn.focus();
                break;
            }
          });
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setSlots = function () {
    var slotLength;
    var slotTiming;
    var columnLength;
    var slotsColumn;
    var slotsCount;
    var setTop = 0;
    var setLeft = 0;
    var rowCount = 0;
    var columnCount = 0;
    var timeslotsRow = this.timeSlotsContainer.find('tr');
    var timeslotsRowValue = timeslotsRow.eq(rowCount).find('td').eq(columnCount);
    var timeslotsRowWidth = timeslotsRowValue[0].getBoundingClientRect().width - 1;
    var timeslotsRowHeight = timeslotsRowValue[0].getBoundingClientRect().height;
    var slotRowLength = timeslotsRow.length;
    var timeslots = this.calData.timeslots;
    var timeslotsCalendar = this.container.find('.weekdays').hasClass('calendar-view');

    if (!timeslots) {
      return;
    }
    this.firstDay.setHours(0, 0, 0, 0);
    // iterate over all artist-open date/times received in API response
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = dateUtils.convertTimeString(timeslots[i].start_date),
        end = dateUtils.convertTimeString(timeslots[i].end_date),
        startTime = start.getTime();

      // if a date falls between start & end date of calendar, pass it to display logic
      if (startTime >= this.firstDay.getTime() && startTime <= this.lastDay.getTime()) {
        this.processSlot(start, end, this.timeSlotInterval);
      }
    }
    if (!site.client.isMobile && timeslotsCalendar) {
      this.timeSlotsContainer.find('td').hide();
      for (slotTiming = 0; slotTiming < slotRowLength; slotTiming += 1) {
        slotsColumn = timeslotsRow.eq(rowCount).find('td');
        slotsCount = slotsColumn.eq(columnCount);
        columnLength = slotsColumn.length;
        slotLength = slotRowLength - 1;
        if (slotsCount.hasClass('enabled')) {
          slotsCount
            .css({
              top: setTop,
              left: setLeft
            })
            .show();
          slotsCount.css('position', 'absolute');
          setTop += timeslotsRowHeight;
        }
        rowCount++;
        if (slotTiming === slotLength && columnCount < columnLength) {
          slotTiming = 0;
          rowCount = 0;
          setTop = 0;
          setLeft += timeslotsRowWidth;
          columnCount++;
        }
      }
      this.timeSlotsContainer.find('td').each(function () {
        var $ele = $(this);

        if (!$ele.hasClass('enabled')) {
          $ele.remove();
        }
      });
    }
  };

  apptBook.CalendarTimeSlots.prototype.setApptTime = function () {
    var me = this,
      apptDate = dateUtils.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString(),
      apptMinutes = ('0' + apptDate.getMinutes()).slice(-2),
      apptTimeDate = apptHour + ':' + apptMinutes;

    if (apptTime >= this.firstDay.getTime() && apptTime <= this.lastDay.getTime()) {
      this.timeSlotsContainer.find('.day-' + startDayShift(apptDate.getDay())).each(function () {
        var $this = $(this);
        var $hour = $(this).attr('data-hour');

        if ($this.attr('data-hour') === apptTimeDate) {
          $this.addClass('selected').addClass('enabled');
          me.model.setSelection(apptDate, me);
        }
      });
    }
  };

  apptBook.CalendarTimeSlots.prototype.convertDateString = function (tString) {
    if (typeof tString != 'string' || tString.match(/^\d\d\d\d-\d\d-\d\d$/) === null) {
      return null;
    }
    var dateArray, y, m, d;

    dateArray = tString.split('-');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);

    return new Date(y, m, d);
  };

  /**
   * CalDatePicker is a class faor a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePicker = function (options) {
    apptBook.CalDatePicker.superclass.constructor.call(this);
    var offSet,
      me = this,
      $bod = options.jqBod,
      overlay = options.overlay,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      weekContainer = options.weekContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      days = options.dayNames,
      months = options.monthNames,
      year_suffix = options.yearSuffix,
      pikaday = new Pikaday({
        field: dpField[0],
        firstDay: oab_start_from_monday ? 1 : 0,
        minDate: new Date(),
        maxDate: new Date(2020, 12, 31),
        yearRange: [2000, 2020],
        yearSuffix: oab_year_suffix,
        bound: false,
        showMonthAfterYear: oab_show_month_after_year ? true : false,
        yearSuffix: oab_show_year_suffix ? year_suffix : '',
        container: calContainer[0],
        numberOfMonths: 1,
        onSelect: onDateSelect,
        disableDayFn: disableDate,
        i18n: {
          previousMonth: '',
          nextMonth: '',
          months: months,
          weekdays: days,
          weekdaysShort: days
        }
      });

    $bod.prepend(overlay);

    function openOverlay() {
      overlay.css('display', 'block');
      if (!me.model.isDateSelected) {
        month = me.model.calData.myDate.getMonth();
        currentMonth = me.model.calData.currentDate.getMonth();
        pikaday.gotoMonth(month);
        if (month != currentMonth) {
          me.model.datepickerContainer.find('.is-selected').removeClass('is-selected');
        }
      } else {
        pikaday.gotoDate(me.model.calData.myDate);
      }
    }

    function closeOverlay() {
      overlay.css('display', 'none');
    }

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.calData.currentDate = d;
        me.model.isDateSelected = true;
        me.model.update({
          date: d,
          hilite: true,
          apptDur: me.model.calData.apptDur,
          apptDurWithPadding: me.model.calData.apptDurWithPadding
        });
      }
      closeOverlay();
      me.model.calData.showNextWeek = false;
    }

    function disableDate(date) {
      if (!me.model) {
        return;
      }
      // build key from date values
      var dateKey = dateUtils.dateToString(date, 'yyyy-mm-dd');
      // use that key to look up store-open times for that day
      var openTimes = me.model.calData.openTimes;
      var datesInvalid = me.model.calData.datesInvalid;

      if (typeof openTimes[dateKey] === 'undefined' || !openTimes[dateKey].length) {
        return date;
      }
      if ($.inArray(dateKey, datesInvalid) >= 0) {
        return date;
      }
    }

    dpTrigger.click(openOverlay);
    closeBtn.click(closeOverlay);
    // ADA, Appointment booking page calender
    dpTrigger.keydown(function (e) {
      $target = $(this);
      var $calenderContainer = $('.js-overlay-container');

      if (site.getKeycode(e) === 13) {
        var $expanded = $target.attr('aria-expanded');

        if ($expanded === 'true') {
          $target.attr('aria-expanded', 'false');
          closeOverlay();
          $target.focus();
        } else {
          $target.attr('aria-expanded', 'true');
          openOverlay();
          $('.pika-table').find('td button.pika-button.pika-day:eq(0)').focus();
          site.restrict_navigation($calenderContainer),
            $('td.is-disabled button.pika-button.pika-day').attr('tabindex', '-1');
        }
      }
    });
  };

  ctrlopt.extend(apptBook.CalDatePicker, ctrlopt.mvc.AbstractController);

  /* Mobile Appointment Select */

  /* Mobile Date Picker - Date Picker */

  /**
   * CalDatePickerMobile is a sub-class of CalDatePicker. It is a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePickerMobile = function (options) {
    apptBook.CalDatePickerMobile.superclass.constructor.call(this);
    var me = this,
      foregroundNode,
      backgroundNode,
      overlay = options.overlay,
      $bod = options.jqBod,
      container = options.container,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      days = options.dayNames,
      months = options.monthNames,
      dpControls = options.dpControls,
      year_suffix = options.yearSuffix;

    $bod.prepend(overlay);

    pikaday = new Pikaday({
      field: dpField[0],
      firstDay: 0,
      minDate: new Date(),
      maxDate: new Date(2020, 12, 31),
      yearRange: [2000, 2020],
      bound: false,
      showMonthAfterYear: oab_show_month_after_year ? true : false,
      yearSuffix: oab_show_year_suffix ? year_suffix : '',
      container: calContainer[0],
      onSelect: onDateSelect,
      disableDayFn: disableDate,
      i18n: {
        months: months,
        weekdays: days,
        weekdaysShort: days
      }
    });

    function disableDate(date) {
      if (!me.model) {
        return;
      }
      // build key from date values
      var dateKey = dateUtils.dateToString(date, 'yyyy-mm-dd');
      // use that key to look up store-open times for that day
      var openTimes = me.model.calData.openTimes;
      var datesInvalid = me.model.calData.datesInvalid;

      if (typeof openTimes[dateKey] === 'undefined' || !openTimes[dateKey].length) {
        return date;
      }
      if ($.inArray(dateKey, datesInvalid) >= 0) {
        return date;
      }
    }

    function openOverlay() {
      me.model.winPos = $(window).scrollTop();
      me.model.headContent = $(this).find('.cal-copy');
      me.model.hDefContent = $(this).find('.default-cal-copy');
      $(window).scroll(0);
      container.scrollTop(0);
      h = $(window).height() - 10;
      var timeSlotData = me.model.calData.timeslots;
      var currentAvaialableDateSlot;
      var activeTimeSlot;
      var selectedDate;

      overlay.addClass('overlay-container').css('display', 'block');
      pikaday.gotoDate(new Date());
      if (timeSlotData.length) {
        currentAvaialableDateSlot = timeSlotData[0].start_date;
        activeTimeSlot = currentAvaialableDateSlot.split(/[- :]/);
        selectedDate = currentAvaialableDateSlot.replace(/-/g, '/');
        overlay.find('.js-date-picker-no-slot').addClass('hidden');
        overlay.find('td').removeClass('is-selected');
        overlay.find('td[data-day=' + Number(activeTimeSlot[2]) + ']').addClass('is-selected');
        me.model.update({
          date: new Date(selectedDate),
          apptDur: me.model.calData.apptDur,
          apptDurWithPadding: me.model.calData.apptDurWithPadding
        });
      }
    }

    function closeOverlay() {
      overlay.css('display', 'none');
      $(window).scrollTop(me.model.winPos);
    }

    function onDateSelect(e) {
      var d = pikaday.getDate();

      me.model.isDateSelected = true;
      if (me.model) {
        me.model.update({
          date: d,
          hilite: true,
          apptDur: me.model.calData.apptDur,
          apptDurWithPadding: me.model.calData.apptDurWithPadding
        });
      }
    }

    dpTrigger.click(openOverlay);
    closeBtn.click(closeOverlay);
  };

  ctrlopt.extend(apptBook.CalDatePickerMobile, ctrlopt.mvc.AbstractController);

  /* End Mobile Date Picker */

  /* Mobile Calendar Header */

  /**
   * CalendarHeaderMobile is a sub-class of CalendarHeader. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeaderMobile = function (header) {
    apptBook.CalendarHeaderMobile.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.hDefContent = this.header.find('.default-cal-copy');
    this.headContent = this.header.find('.cal-copy');
    this.headCopy = this.headContent.html();
    this.months = this.header.attr('data-months').split(',');
  };

  ctrlopt.extend(apptBook.CalendarHeaderMobile, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeaderMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      headOutIni,
      headOutEnd,
      firstDay,
      lastDay,
      myDate,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = myDate.getDay(),
      myDateEnd = new Date(myDate.getTime());

    myDateEnd.setTime(myDateEnd.getTime() + me.model.calData.apptDur * 60000);

    firstDay = new Date(myDate.getTime());
    firstDay.setDate(firstDay.getDate() - dayOfWeek);
    firstDay.setHours(0, 0, 0, 0);

    lastDay = new Date(firstDay.getTime());
    lastDay.setDate(lastDay.getDate() + 6);
    lastDay.setHours(23, 59, 59, 999);

    headOutIni = this.months[firstDay.getMonth()] + ' ' + firstDay.getDate() + ', ' + firstDay.getFullYear();
    headOutEnd = this.months[lastDay.getMonth()] + ' ' + lastDay.getDate() + ', ' + lastDay.getFullYear();

    // headOut = this.months[myDate.getMonth()] + " " + myDate.getDate() + ", " + myDate.getFullYear() + " " + myDate.getHours() + ":" + ("0" + myDate.getMinutes()).slice(-2) + this.headCopy + myDateEnd.getHours() + ":" + ("0" + myDateEnd.getMinutes()).slice(-2);

    var hours = myDate.getHours();
    var suffix = '';

    if (!oab_time_format_24h) {
      suffix = hours < 12 ? 'AM' : 'PM';
      hours = ((myDate.getHours() + 11) % 12) + 1;
    }
    if (kr_day_month_format) {
      headOut =
        myDate.getFullYear() +
        oab_year_suffix +
        ' ' +
        this.months[myDate.getMonth()] +
        ' ' +
        myDate.getDate() +
        this.header.attr('data-day-suffix') +
        ' ' +
        this.headCopy;
    } else {
      headOut = this.months[myDate.getMonth()] + ' ' + myDate.getDate() + ', ' + myDate.getFullYear() + ' ';
    }

    if (oab_date_format_jp) {
      headOut =
        myDate.getFullYear() +
        oab_year_suffix +
        ' ' +
        this.months[myDate.getMonth()] +
        oab_month_suffix +
        ' ' +
        myDate.getDate() +
        oab_day_suffix +
        ' ';
    } else {
      headOut = oab_cal_header_tmpl_mobile;
      headOut = headOut.replace('[d]', myDate.getDate());
      headOut = headOut.replace('[m]', this.months[myDate.getMonth()]);
      headOut = headOut.replace('[y]', myDate.getFullYear());
      headOut = headOut.replace('[ys]', oab_year_suffix);
      headOut = headOut.replace('[ms]', oab_month_suffix);
      headOut = headOut.replace('[ds]', oab_day_suffix);
    }

    headOut += hours + ':' + ('0' + myDate.getMinutes()).slice(-2) + ' ' + suffix;

    this.headContent.html(headOut);
  };

  /* End Mobile Calendar Header */

  /* Mobile Time Slot Select */

  /**
   * CalendarTimeSlotsMobile is a sub-class of CalendarTimeSlots. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Mobile Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlotsMobile = function (options) {
    apptBook.CalendarTimeSlotsMobile.superclass.constructor.call(this, options);
  };

  ctrlopt.extend(apptBook.CalendarTimeSlotsMobile, apptBook.CalendarTimeSlots);

  apptBook.CalendarTimeSlotsMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    if (!this.initialized) {
      this.buildWeekView();
      this.initialized = true;
    } else {
      this.timeSlotsElems.removeClass('selected');
      this.buildWeekView();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setCellDateTimes = function () {
    var $tds = this.timeSlotsElems;
    var myDateTime = new Date(this.calData.myDate);

    $tds.each(function (idx) {
      var $td = $(this);
      var parts = $td.data('hour').split(':');

      myDateTime.setHours(parts[0], parts[1], 0, 0);
      $td.attr('data-date-time', myDateTime);
    });
  };

  apptBook.CalendarTimeSlotsMobile.prototype.scrollToOpenTime = function () {
    var $tds = this.timeSlotsElems;
    // switched from .store_open to .enabled - forward the user to the first available timeslot
    var $firstOpen = $tds.filter('.enabled').first();
    var winTop = $(window).scrollTop();
    var parent = this.model.datepickerContainer.parents('.date-picker-container');

    if ($firstOpen.length) {
      parent.animate({ scrollTop: parent.scrollTop() + $firstOpen.offset().top - winTop }, 1000);
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.buildWeekView = function () {
    var hour, sText, row, rowCount, rows, rowIdx, tds, tdPerRow, tdElem, mod, cur, td;
    var myDate = this.calData.myDate;

    if (!this.initialized) {
      this.tds = this.timeSlotRow.find('td').remove();
      this.tdPerRow = this.tds.length;
    }
    tdElem = this.tds.first();
    rowCount = Math.ceil(this.slots.length / this.tdPerRow);

    if (this.initialized) {
      this.timeSlotsContainer.empty();
    }
    for (var i = 0; i < rowCount; i += 1) {
      row = this.timeSlotRow.clone();
      this.timeSlotsContainer.append(row);
    }

    rows = this.timeSlotsContainer.find('tr');
    i = 0;
    rowIdx = 0;
    openTimes = this.calData.openTimes;

    if (typeof this.calData.timeSlotInterval != 'undefined') {
      this.timeSlotInterval = this.calData.timeSlotInterval;
    }

    var intervalFactor = this.timeSlotInterval / 15;

    // value of 0 should be treated as 60
    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    for (var len = this.slots.length; i < len; i += intervalFactor) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;

      td = tdElem.clone();

      var myDateTime = myDate ? new Date(myDate.getTime()) : new Date();

      myDateTime.setHours(hour.split(':')[0], hour.split(':')[1], 0, 0);

      var to = new Date(myDateTime.getTime()); // Open Store Time Slot
      var tc = new Date(myDateTime.getTime()); // Close Store Time Slot
      var openTimesDateKey = dateUtils.dateToString(myDateTime, 'yyyy-mm-dd');

      if (typeof openTimes[openTimesDateKey] !== 'undefined' && openTimes[openTimesDateKey].length) {
        // loop through all available openTimesDateKey keys since there may multiple start and end times for a given day
        var slot_is_available = false;

        for (var j = 0; j < openTimes[openTimesDateKey].length; j++) {
          // get HH:mm:ss string for the open & close times
          var openStoreHourStr = openTimes[openTimesDateKey][j]['start_time'].split(':');
          var closeStoreHourStr = openTimes[openTimesDateKey][j]['end_time'].split(':');

          // get Date objects for the open & close times
          to.setHours(openStoreHourStr[0], openStoreHourStr[1], 0, 0);
          tc.setHours(closeStoreHourStr[0], closeStoreHourStr[1], 0, 0);
          if (myDateTime.getTime() >= to.getTime() && myDateTime.getTime() < tc.getTime()) {
            slot_is_available = true;
          }
        }
        if (!slot_is_available) {
          td.text(this.closedCopy); // Set this time slot as Closed.
          td.addClass('store_closed');
        } else {
          td.text(sText);
        }
      } else {
        td.text(sText);
      }
      td.attr('data-hour', hour);

      rows.eq(rowIdx).append(td);

      cur = i + 1;
      mod = cur % this.tdPerRow;

      if (mod === 0) {
        rowIdx += 1;
      }
    }
    this.timeSlotsElems = this.timeSlotsContainer.find('td');
    this.setCellDateTimes();
    this.setSlots();
    if (this.calData.apptTime) {
      this.setApptTime();
    }
    if (this.calData.openTimes) {
      this.handleStoreOpenTimes();
    }
    this.scrollToOpenTime();
  };

  apptBook.CalendarTimeSlotsMobile.prototype.processSlot = function (start, end, interval) {
    var startIndex = 0,
      myDay = new Date(start.getTime()),
      myDayOfWeek = myDay.getDay(),
      todayDate = new Date(),
      stateofDay = this.container.attr('data-day-status'),
      col = this.timeSlotsContainer.find('.day-' + myDayOfWeek);

    interval = interval ? interval : 60;
    var dMinute = Math.ceil(start.getMinutes() / interval),
      startHour = dMinute * interval === 60 ? start.getHours() + 1 : start.getHours(),
      startMin = dMinute * interval === 0 || dMinute * interval === 60 ? '00' : dMinute * interval,
      startTime = startHour + ':' + startMin,
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this;
    var intervalFactor = this.timeSlotInterval / 15;

    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    for (var i = 0; i < len; i += intervalFactor) {
      if (this.slots[i].hour === startTime) {
        startIndex = i;
        break;
      }
    }

    for (i = startIndex; i < len; i += intervalFactor) {
      var timeLeft,
        minLeft,
        sT = this.slots[i].hour.split(':');

      sHrDate.setHours(sT[0], sT[1], 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDurWithPadding) {
        break;
      } else {
        this.timeSlotsElems
          .eq(parseInt(i / intervalFactor))
          .addClass('enabled')
          .click(function (e) {
            var slotDate = new Date(start.getTime()),
              hour,
              min,
              $this = $(this);

            me.timeSlotsElems.removeClass('selected');
            $this.addClass('selected');
            hour = $this.attr('data-hour').split(':')[0];
            min = $this.attr('data-hour').split(':')[1];
            slotDate.setHours(parseInt(hour, 10));
            slotDate.setMinutes(parseInt(min));
            me.model.setSelection(slotDate, me);
          });
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots,
      myDate = new Date(this.calData.myDate.getTime());

    myDate.setHours(0, 0, 0, 0);

    this.timeSlotsElems.removeClass('enabled').off('click');

    if (!timeslots) {
      return;
    }
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = dateUtils.convertTimeString(timeslots[i].start_date),
        startDay = new Date(start.getTime());

      startDay.setHours(0, 0, 0, 0);
      if (startDay.getTime() === myDate.getTime()) {
        this.processSlot(start, dateUtils.convertTimeString(timeslots[i].end_date), this.timeSlotInterval);
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setApptTime = function () {
    var me = this,
      apptDate = dateUtils.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString(),
      apptMinutes = ('0' + apptDate.getMinutes()).slice(-2),
      apptTimeDate = apptHour + ':' + apptMinutes;
  };

  /* End Mobile Time Slot Select */

  var dateUtils = {
    // Source: http://stackoverflow.com/questions/497790
    // That's right, I copied it from Stack Overflow.
    convert: function (d) {
      // Converts the date in d to a date-object. The input can be:
      //   a date object: returned without modification
      //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
      //   a number     : Interpreted as number of milliseconds
      //                  since 1 Jan 1970 (a timestamp)
      //   a string     : Any format supported by the javascript engine, like
      //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
      //  an object     : Interpreted as an object with year, month and date
      //                  attributes.  **NOTE** month is 0-11.
      return d.constructor === Date
        ? d
        : d.constructor === Array
        ? new Date(d[0], d[1], d[2])
        : d.constructor === Number
        ? new Date(d)
        : d.constructor === String
        ? new Date(d)
        : typeof d === 'object'
        ? new Date(d.year, d.month, d.date)
        : NaN;
    },
    compare: function (a, b) {
      // Compare two dates (could be of any type supported by the convert
      // function above) and returns:
      //  -1 : if a < b
      //   0 : if a = b
      //   1 : if a > b
      // NaN : if a or b is an illegal date
      // NOTE: The code inside isFinite does an assignment (=).
      return isFinite((a = this.convert(a).valueOf())) && isFinite((b = this.convert(b).valueOf()))
        ? (a > b) - (a < b)
        : NaN;
    },
    inRange: function (d, start, end) {
      // Checks if date in d is between dates in start and end.
      // Returns a boolean or NaN:
      //    true  : if d is between start and end (inclusive)
      //    false : if d is before start or after end
      //    NaN   : if one or more of the dates is illegal.
      // NOTE: The code inside isFinite does an assignment (=).
      return isFinite((d = this.convert(d).valueOf())) &&
        isFinite((start = this.convert(start).valueOf())) &&
        isFinite((end = this.convert(end).valueOf()))
        ? start <= d && d < end
        : NaN;
    },
    dateToString: function (date, format) {
      var str = date.toLocaleString();

      switch (format) {
        case 'yyyy-mm-dd':
          var thisMonthString = date.getMonth() + 1;

          thisMonthString = thisMonthString < 10 ? '0' + thisMonthString : '' + thisMonthString;
          var thisDateString = date.getDate();

          thisDateString = thisDateString < 10 ? '0' + thisDateString : '' + thisDateString;
          str = date.getFullYear() + '-';
          str += thisMonthString + '-';
          str += thisDateString;
          break;
        default:
          break;
      }

      return str;
    },
    // tests 2 date ranges for overlap
    // @param r1 Array required [start date, end date]
    // @param r2 Array required [start date, end date]
    compareRanges: function (r1, r2) {
      if (r2[0] > r1[1]) {
        return false;
      }
      if (r2[1] < r1[0]) {
        return false;
      }

      return true;
    },
    //
    // converts string to date object, from format "yyyy-mm-dd hh:MM" ONLY
    convertTimeString: function (tString) {
      var split, dateArray, timeArray, y, m, d, hr, min, sec;

      split = tString.split(' ');
      dateArray = split[0].split('-');
      timeArray = split[1].split(':');

      y = parseInt(dateArray[0], 10);
      m = parseInt(dateArray[1], 10) - 1;
      d = parseInt(dateArray[2], 10);
      hr = parseInt(timeArray[0], 10);
      min = parseInt(timeArray[1], 10);
      sec = parseInt(timeArray[2], 10);

      return new Date(y, m, d, hr, min, sec);
    }
  }; // end dateUtils

  Drupal.behaviors.apptBookAppointments = {
    attach: function (context) {
      var view = new apptBook.AppointmentSelectSection($('#appointments'));

      view.setModel(apptBook.sectionModel).startObserving();
      var self = this;

      $('.artist-info', context).on('click', function () {
        $.colorbox.remove();
        var artistNode = $('#appointments', context).attr('data-artist-node');

        $.ajax({
          url: 'https://' + window.location.host + '/elc_api/' + artistNode + '/',
          type: 'GET',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Accept', 'HTML');
          },
          success: function (data) {
            $.colorbox.remove();
            var content =
              '<div class="app-artist-info">' +
              $('#' + artistNode.replace('/', '-') + ' .content', data.rendered).html() +
              '</div>';
            var artistDescLimit = 200;
            var colorboxSettings = {
              html: content,
              close: '<i class="icon icon--close"></i>',
              className: 'appt-artist-overlay',
              width: '60%',
              transition: 'none',
              opacity: '0.7',
              closeButton: true,
              onComplete: function () {
                var cboxContent = $('#cboxContent');

                $('#cboxOverlay').addClass('appt-artist-overlay');
                $('#colorbox').addClass('appt-artist-overlay');
                $('#cboxLoadedContent', cboxContent).css({
                  width: '100%',
                  height: '460px'
                });
                $('.app-artist-info').slick({
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  variableWidth: true,
                  infinite: false,
                  responsive: [
                    {
                      breakpoint: 640,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        centerMode: true
                      }
                    }
                  ]
                });
                $('.app-artist-info').removeClass('slick-arrow');
                $('.app-artist-info').addClass('slick-arrow');
                $('.artist-description', cboxContent).each(function () {
                  var artistFullDesc = $(this).text();

                  if (artistFullDesc.length > artistDescLimit) {
                    var firstSet = artistFullDesc.substring(0, artistDescLimit);
                    var secondHalf = artistFullDesc.substring(artistDescLimit, artistFullDesc.length);

                    $(this).empty().html(firstSet);
                    $(this).append('<a href="javascript:void(0);" class="read-more">...</a>');
                    $(this).append('<span class="more-text hidden">' + secondHalf + '</span>');
                  }
                });
                $('.read-more', cboxContent).click(function () {
                  $(this).parent().find('.more-text').removeClass('hidden');
                  $(this).parent().find('.read-more').addClass('hidden');
                });
                $('.slick-dots li button, .slick-prev, .slick-next', cboxContent).click(function () {
                  $('.artist-description', cboxContent).each(function () {
                    $(this).find('.more-text').addClass('hidden');
                    $(this).find('.read-more').removeClass('hidden');
                  });
                });
              }
            };
            var colorboxPcSettings = {
              width: '688px',
              height: '460px'
            };
            var colorboxMobileSettings = {
              width: '90%',
              height: '460px'
            };
            var overlay = $.extend(
              {},
              colorboxSettings,
              +site.client.isMobile ? colorboxMobileSettings : colorboxPcSettings
            );

            self.openWindow(overlay);
          }
        });
      });
    },
    openWindow: function (overlay) {
      $.colorbox(overlay);
    }
  };
  apptBook.confirmAccount = function (container) {
    apptBook.confirmAccount.superclass.constructor.call(this);
    this.id = 'confirm';
    this.jqBod = $('body');
    this.container = container;
    this.signInContainer = container.find('.sign-in-container');
    this.bookContainer = container.find('.book-appt-container');
    this.confContainer = container.find('.booking-container');
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.calendarId = '0';
    this.appointmentId = null;
    this.serviceIds = [];
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.confirmAccount, apptBook.AbstractSection);

  apptBook.confirmAccount.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Confirm Account & Book';

    this.serviceIds = [];
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointmentId) {
        me.model.getAppointment(
          data.params.appointmentId,
          function (apptData) {
            me.updateMode = true;
            me.counterId = data.params.counter_id;
            me.calendarId = data.params.calendar_id;
            me.serviceIds = data.params.serviceIds;
            me.appointmentId = apptData.id;
            me.startTime = data.params.startTime;

            me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
              me.counterData = data;
              hasCounter = true;
              runUpdate();
            });
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        me.counterId = data.params.counter_id;
        me.startTime = data.params.start_time;
        me.calendarId = data.params.calendar_id;
        me.serviceIds = data.params.serviceIds;
        me.services = data.params.services;
        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      me.model.fetchCountersData({ service_id: this.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        // params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };
})(jQuery);
